import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProjectDashboard } from '../modules/ProjectDashboard';

export const Route = createFileRoute('/project/$projectId')({
  component: ProjectDashboard,
  params: z.object({
    projectId: z.coerce.number().positive(),
  }),
  // Phone layout: which tab is showing, and a note or a section open as its own page, so
  // the phone's back button closes it and a refresh keeps it. The record checks `section`
  // against the sections the user can see.
  validateSearch: z.object({
    tab: z.enum(['jobs', 'notes', 'budget']).optional().catch(undefined),
    note: z.coerce.number().positive().optional().catch(undefined),
    section: z.string().optional().catch(undefined),
    changeOrder: z.string().optional().catch(undefined),
  }),
  async loader(ctx) {
    // Note: projectId in URL is actually the primaryEventId (what technicians see)
    // Skip the loader query for now since we handle this in the component
    return {
      projectId: ctx.params.projectId, // This is actually primaryEventId
      project: null, // Let the component handle loading
    };
  },
  head(ctx) {
    return {
      meta: [{ title: `Project Dashboard | ${ctx.params.projectId}` }],
    };
  },
});
